module.exports = __webpack_public_path__ + "img/back-icon.d66f7446.svg";